<template>
<div>
    <div class="d-flex justify-space-between mb-2">
        <div class="d-flex justify-center align-center">
            <div class="img_title_bill_retrospect">
                <img src="@/assets/icon-restaurant-close-restaurant.png">
            </div>
            <h2 class="title_bill_retrospect">รายการปิดร้านย้อนหลัง</h2>
        </div>

        <v-btn class="grad-primary-bg white--text titlefont_bill_retrospect" height="50" width="20%" @click="$router.push('/restaurant')">
            ย้อนกลับ
        </v-btn>
    </div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show === true">ยกเลิกบิลเรียบร้อย</v-alert>
        <v-alert type="danger" class="alert_success" v-if="message_fail === true">เกิดข้อผิดพลาด กรุณาลองอีกคร้ัง</v-alert>
        <v-alert type="warning" class="alert_success" v-if="alert_waiting === true">กำลังทำการพิมพ์ใบเสร็จกรุณารอสักครู่...</v-alert>
    </v-slide-x-reverse-transition>


    <v-card>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div v-if="loading_page === false">
            <div class="pa-4">
                <div class="d-flex justify-space-between align-center">
                    <div class="startdate_sale_statistic mr-1">
                    <v-menu ref="menu_start_date" v-model="menu_start_date" :close-on-content-click="false" :return-value.sync="start_date" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="start_date_be" label="วันที่เริ่ม (วัน/เดือน/ปี)" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="start_date" :max="end_date" no-title scrollable locale="th" :events="dateStartEndBE('start_date')">
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="searchDate('start_date')">
                            ตกลง
                        </v-btn>
                        <v-btn text color="primary" @click="menu_start_date = false">
                            ยกเลิก
                        </v-btn>
                        </v-date-picker>
                    </v-menu>
                    </div>

                    <div class="enddate_sale_statistic ml-1">
                    <v-menu ref="menu_end_date" v-model="menu_end_date" :close-on-content-click="false" :return-value.sync="end_date" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="end_date_be" label="วันที่สิ้นสุด (วัน/เดือน/ปี)" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="end_date" :min="start_date" no-title scrollable locale="th" :events="dateStartEndBE('end_date')">
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="searchDate('end_date')">
                            ตกลง
                        </v-btn>
                        <v-btn text color="primary" @click="menu_end_date = false">
                            ยกเลิก
                        </v-btn>
                        </v-date-picker>
                    </v-menu>
                    </div>
                </div>
                <div class="col-12 d-flex justify-center">
                    <v-btn color="#1094C7" class="white--text titlefont_poslist mx-2" type="submit" height="50" @click="exportPDFCloseStore">
                    ดาวน์โหลดรายงาน ไฟล์ PDF
                    </v-btn>

                    <v-btn color="#28ab28" class="white--text titlefont_poslist mx-2" type="submit" height="50" @click="exportExcelCloseStore">
                    ดาวน์โหลดรายงาน ไฟล์ Excel
                    </v-btn>
                </div>
            </div>
            <v-card-title>
                <v-text-field v-model="search" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <div>
                <v-data-table :headers="headers" :items="data" :search="search">
                    <template v-slot:item="dataDetail">
                        <tr>
                            <td>{{dataDetail.item.created_at}}</td>
                            <td>{{dataDetail.item.restaurant_close_time}}</td>
                            <td>{{dataDetail.item.price_total}}</td>
                            <td>{{dataDetail.item.price_delivery_total}}</td>
                            <td :class="dataDetail.item.status == 'ปิดร้านด้วยตนเอง' ? 'success--text text-18' : dataDetail.item.status == 'ปิดร้านอัตโนมัติ' ? 'warning--text text-18' : ''">{{dataDetail.item.status}}</td>
                            <td>
                                <span class="detail_bill_retrospect mr-3" @click="detailCloseRetrospect(dataDetail.item.id)">
                                    <v-icon right color="grey">mdi-pencil-box-outline</v-icon>
                                </span>
                                <v-btn dark class="white--text ma-1" width="170" height="35" @click="confirmPrint(dataDetail.item.id)">พิมพ์ใบปิดร้าน</v-btn>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </div>
            
        </div>
    </v-card>

    <v-dialog v-model="open_confirm_print" persistent max-width="600">
        <v-card>
            <v-form @submit.prevent="printBill()">
                <v-card-title>
                    ยืนยันการพิมพ์
                </v-card-title>

                <v-card-text>
                    <div class="mb-2">
                        ต้องการพิมพ์ใบสรุปยอดย้อนหลัง นี้ใช่หรือไม่ ??
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#28ab28" class="white--text" type="submit">
                        ตกลง
                    </v-btn>
                    <v-btn color="error" @click="open_confirm_print = false">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
    
    <NotFoundDialog v-model="dialogVisible" @retry="clearSearch"/>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import NotFoundDialog from "@/components/menuadmin/NotFoundDialog.vue";
export default {
    name: 'closeRetrospectall',
    components: {
        NotFoundDialog,
    },
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: false,
            search: '',
            headers: [{
                    text: 'วันที่',
                    align: 'date',
                    value: 'created_at',
                },
                {
                    text: 'เวลาปิดร้าน',
                    value: 'restaurant_close_time'
                },
                {
                    text: 'ยอดขายหน้าร้าน',
                    value: 'price_total'
                },
                {
                    text: 'ยอดขายเดลิเวอร์รี่',
                    value: 'price_delivery_total'
                },
                {
                    text: 'สถานะ',
                    value: 'status'
                },
                {
                    text: 'ดูรายละเอียด',
                    value: 'action'
                },
            ],
            data: [],
            open_confirm_print: false,
            selectedStatisticId: null, // เพิ่มบรรทัดนี้เข้ามา
            menu_start_date: false,
            menu_end_date: false,
            start_date_be: '',
            start_date: '',
            end_date_be: '',
            end_date: '',
            source_store_select:0,
            type_product_select:0,
            source_store_list:[{
                source_name:'ทั้งหมด',
                id:0
            }],
            type_product_list:[{
                name:'ทั้งหมด',
                id:0
            }],
            dialogVisible:false
        }
    },
    methods: {
         // ... เมธอดอื่นๆ
        confirmPrint(id) {
            this.selectedStatisticId = id; // เก็บ ID ที่เลือก
            this.open_confirm_print = true; // เปิด Dialog ยืนยัน
        },
        async printBill() {
            try {
                const response = await HTTP.post('/updatePrintStatus', {
                    id: this.selectedStatisticId
                }, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                });

                if (response.data.successful === true) {
                    // อัปเดตสำเร็จ
                    this.alert_waiting = true
                    setTimeout(() => this.alert_waiting = false, 5000)
                    this.open_confirm_print = false; // ปิด Dialog
                    // อาจจะแสดงข้อความสำเร็จ หรือรีเฟรชข้อมูลในตาราง
                    // this.closeRetrospectList(); // หากต้องการรีเฟรชข้อมูลในตาราง
                } else {
                    // console.error('Failed to update status:', response.data.message);
                    this.message_fail = true
                    setTimeout(() => this.message_fail = false, 5000)
                    this.open_confirm_print = false; // ปิด Dialog
                    // จัดการกรณีที่ API แจ้งว่าไม่สำเร็จ
                }
            } catch (error) {
                console.error('Error updating status:', error);
                if (error.response && error.response.status === 401) {
                    this.$store.commit('logOutSuccess');
                    this.$router.push('/login');
                }
                // จัดการข้อผิดพลาดอื่นๆ
            }
        },
        async closeRetrospectList() {
            this.loading_page = true
            this.data = []
            HTTP.post('/listCloseStore', {date_start:this.start_date,date_end:this.end_date}, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        response.data.list.forEach(detail => {
                            let status = null
                            if (detail.status == 0) {
                                status = 'ปิดร้านด้วยตนเอง'
                            }
                            if (detail.status == 1) {
                                status = 'ปิดร้านอัตโนมัติ'
                            }
                            if (detail.status == null) {
                                status = '-'
                            }
                            this.data.push({
                                id:detail.id,
                                created_at:detail.created_at,
                                restaurant_close_time:detail.restaurant_close_time,
                                price_total:detail.price_total,
                                price_delivery_total:detail.price_delivery_total,
                                status:status,
                            })
                        })
                        this.loading_page = false
                        if(response.data.list == ''){
                            this.dialogVisible = true;
                        }
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async detailCloseRetrospect(id){
            const idPage = {
                id:id
            }
            this.$store.commit('detailCloseRetrospectPage',idPage)
            this.$router.push('/closeretrospectdetail')
        },
        async searchDate(type) {
            if (type == 'start_date') {
                this.$refs.menu_start_date.save(this.start_date)
                let date_arr = this.start_date.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.start_date_be = `${date_arr[2]}/${month}/${year}`
                this.menu_start_date = false
            }
            if (type == 'end_date') {
                this.$refs.menu_end_date.save(this.end_date)
                let date_arr = this.end_date.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.end_date_be = `${date_arr[2]}/${month}/${year}`
                this.menu_end_date = false
            }
            this.closeRetrospectList()
        },
        dateStartEndBE(type) {
            if (type == 'start_date') {
                if (this.start_date == '') {
                this.start_date_be = ''
                }
                if (this.start_date) {
                let date_arr = this.start_date.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.start_date_be = `${date_arr[2]}/${month}/${year}`
                }
            }
            if (type == 'end_date') {
                if (this.end_date == '') {
                this.end_date_be = ''
                }
                if (this.end_date) {
                let date_arr = this.end_date.split('-')
                let year = parseInt(date_arr[0]) + 543
                let month = parseInt(date_arr[1]) - 1
                month = this.$store.state.monthList[month].name_short
                this.end_date_be = `${date_arr[2]}/${month}/${year}`
                }
            }
        },
        async exportExcelCloseStore() {
            HTTP.post('/export-close-store-excel', {date_start:this.start_date,date_end:this.end_date},{
            headers: {
                "Authorization": `Bearer ${this.$store.state.token}`
            },
            responseType: 'blob'
            })
            .then((response) => {
            if (response.status == 200) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const downloadLink = document.createElement('a');
                downloadLink.href = url;
                downloadLink.setAttribute('download', 'close_store.xlsx');
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            }

            })
            .catch((error) => {
            if(error.response.status === 404){
                this.dialogVisible = true;
            }
            if (error.response.status === 401) {
                this.$store.commit('logOutSuccess')
                this.$router.push('/login')
            }
            })
        },
        async exportPDFCloseStore() {
            HTTP.post('/export-close-store-pdf', {date_start:this.start_date,date_end:this.end_date},{
            headers: {
                "Authorization": `Bearer ${this.$store.state.token}`
            },
            responseType: 'blob'
            })
            .then((response) => {
            if (response.status == 200) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const downloadLink = document.createElement('a');
                downloadLink.href = url;
                downloadLink.setAttribute('download', 'close_store.pdf');
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            }

            })
            .catch((error) => {
            if(error.response.status === 404){
                this.dialogVisible = true;
            }
            if (error.response.status === 401) {
                this.$store.commit('logOutSuccess')
                this.$router.push('/login')
            }
            })
        },
        clearSearch(is_retry){            
            if(is_retry){
                this.dialogVisible = false
                this.start_date = ''
                this.end_date = ''
                this.closeRetrospectList()
            }
        }
    },

    mounted(){
        this.closeRetrospectList()
    }

}
</script>
